import Debug from 'debug';
import { processSQLDateTimeGroupDay } from './process-sql-datetime-group-day.js';
import { processSQLDateTimeGroupMonth } from './process-sql-datetime-group-month.js';
import { processSQLDateTimeGroupWeek } from './process-sql-datetime-group-week.js';
import { processSQLDateTimeGroupYear } from './process-sql-datetime-group-year.js';
const debug = Debug(`knack.core.helpers.reports.DateTimeGroup`);
export const processSQLDateTimeGroup = (group, old_filters, field, app_now, report, current_moment_time) => {
    debug(`report-helper.processSQLDateTimeGroup`);
    debug(`adding date filters! range: ${group.range}; limit: ${group.limit}`);
    report.filter_groups.push([]);
    let column = 0;
    old_filters.reverse();
    for (const filter of old_filters) {
        const group_count = (report.filter_groups && report.filter_groups.length) ? report.filter_groups[report.filter_groups.length - 1].length : 0;
        if (group_count > 3000 || report.filters.length > 3000) {
            return false;
        }
        if (group.range === `year`) {
            processSQLDateTimeGroupYear(group, old_filters, app_now, column, filter, report, current_moment_time);
        }
        else if (group.range === `month`) {
            processSQLDateTimeGroupMonth(group, old_filters, app_now, column, filter, report, current_moment_time);
        }
        else if (group.range === `week`) {
            processSQLDateTimeGroupWeek(group, old_filters, app_now, column, filter, report, current_moment_time);
        }
        else if (group.range === `day`) {
            processSQLDateTimeGroupDay(group, old_filters, field, app_now, column, filter, report, current_moment_time);
        }
        column++;
    }
    return true;
};
